import {Component, Inject, OnInit} from '@angular/core';
import {User} from 'projects/core/src/lib/login/data/user';
import {UsersService} from '../../../../users/data/users.service';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {RouteVehicle} from '../../../data/route-vehicle';
import {LogisticRoutesService} from '../../../data/logistic-routes.service';
import {ProjectStatus} from '../../../../project-misc/data/project/statuses/project-status';
import {ActivityForEdit} from '../../../../admin-panel/data/activityi-for-edit';

@Component({
  selector: 'app-logistic-vehicle-edit-dialog',
  templateUrl: './logistic-vehicle-edit-dialog.component.html',
  styleUrls: ['./logistic-vehicle-edit-dialog.component.scss']
})
export class LogisticVehicleEditDialogComponent implements OnInit {
  vehicle: RouteVehicle;

  users: User[]
  selectedUser: User;

  vehicleStatuses: ProjectStatus[]
  selectedVehicleStatus: ProjectStatus;

  activityTypes: ActivityForEdit[]
  selectedActivityType: ActivityForEdit;

  subCount = 0;

  saveLoading = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {
      vehicle: RouteVehicle,
      dialogHeader: string
    },
    protected logisticRoutesService: LogisticRoutesService,
    protected dialogRef: MatDialogRef<LogisticVehicleEditDialogComponent>,
    protected usersService: UsersService,
  ) {
    this.vehicle = this.data.vehicle;
  }

  ngOnInit(): void {
    this.getDeliveryActivityTypes();
    if (this.vehicle.name === 'Personal') {
      this.getAllUsers()
    } else {
      this.getUsers()
    }
    this.getVehicleStatuses()
  }

  getUsers() {
    this.subCount++
    this.usersService.getUsersByRoles(0, 50, 'DeliveryMan,Service Department', true).subscribe(users => {
      //   this.usersService.getUsersByActivityType('JobDelivery').subscribe(users => {
      this.users = users.content

      if (this.vehicle.user) {
        this.selectedUser = this.users.find(usr => usr.id === this.vehicle.user.id)
      }

      this.subCount--
    })

  }

  getAllUsers() {
    this.subCount++
    this.usersService.getActiveUsers().subscribe(users => {
      //   this.usersService.getUsersByActivityType('JobDelivery').subscribe(users => {
      this.users = users

      if (this.vehicle.user) {
        this.selectedUser = this.users.find(usr => usr.id === this.vehicle.user.id)
      }

      this.subCount--
    })
  }

  getVehicleStatuses() {
    this.subCount++
    this.logisticRoutesService.getVehicleStatuses().subscribe(statuses => {
      this.vehicleStatuses = statuses

      if (this.vehicle.status) {
        this.selectedVehicleStatus = this.vehicleStatuses.find(stat => stat.id === this.vehicle.status.id)
      }

      this.subCount--;
    })
  }

  getDeliveryActivityTypes() {
    this.subCount++
    this.logisticRoutesService.getVehicleActivityTypes().subscribe(statuses => {
      this.activityTypes = statuses

      if (this.vehicle.defaultActivityType) {
        this.selectedActivityType = this.activityTypes.find(stat => stat.id === this.vehicle.defaultActivityType.id)
      }

      this.subCount--;
    })
  }

  saveVehicle() {
    this.saveLoading = true;

    this.vehicle.user = this.selectedUser;
    this.vehicle.status = this.selectedVehicleStatus;
    this.vehicle.defaultActivityType = this.selectedActivityType;

    // if (this.vehicle.status?.title === 'Available') {
    //   this.vehicle.routeUrl = null;
    // }

    this.logisticRoutesService.editVehicle(this.vehicle).subscribe(newVeh => {
      this.dialogRef.close(newVeh)
    }, () => {
      this.saveLoading = false;
    })
  }
}
